<template>
  <div class="boss-message-box">
    <img
      src="@/assets/images/avatar-company.svg"
      class="boss-message-box-avatar"
    >
    <div class="boss-message-header-layout">
      <div
        class="boss-layout-block boss-message-when"
        data-test="date"
      >
        {{ date | formatDate }}
        <span
          v-if="isRead"
          data-test="read"
          class="boss-message-status-label boss-message-status-label-read"
        >既読</span>
        <span
          v-else
          data-test="no-read"
          class="boss-message-status-label"
        >未読</span>
      </div>
    </div>
    <div class="boss-layout-block">
      <div
        class="boss-message-mail-subject"
        data-test="subject"
      >
        {{ subject | formatSubject }}
      </div>
      <div
        class="boss-message-mail-body pega-pre-wrap"
        data-test="body"
        v-html="$sanitize(renderBody)"
      />
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import util from '@/lib/util'

export default {
  filters: {
    formatDate (val, defaultLabel = '') {
      return val ? dayjs(val).format('YYYY/MM/DD(ddd) HH:mm') : defaultLabel
    },
    formatSubject (val) {
      return val ? `件名：${val}` : ''
    }
  },
  props: {
    body: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    subject: {
      type: String,
      default: ''
    },
    isRead: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    renderBody () {
      return util.replaceAddressAndUrlLink(this.body)
    }
  }
}
</script>
